import { useTranslation } from 'react-i18next';

// Legacy Motra module colors
const CLASS_COLORS: Record<string, string> = {
  sale: '#72baf9',
  rent: '#FFBC3B',
  job: '#FFED3D',
  tradein: '#f7714c',
  service: '#A2EC3A',
  set: '#72baf9',
  voucher: '#97efe2',
  package: '#3AE9CD',
  schedule: '#eaa3ed',
  consume: '#b39ddb',
};

interface CategorySelectorProps {
  categories: string[];
  selectedCategory: string | null;
  onSelect: (category: string | null) => void;
}

export default function CategorySelector({
  categories,
  selectedCategory,
  onSelect,
}: CategorySelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="category-selector">
      <button
        className={`category-btn${selectedCategory === null ? ' category-btn--active' : ''}`}
        onClick={() => onSelect(null)}
      >
        {t('all', 'All')}
      </button>
      {categories.map((cat) => {
        const color = CLASS_COLORS[cat] ?? '#6b7280';
        const isActive = selectedCategory === cat;
        return (
          <button
            key={cat}
            className={`category-btn${isActive ? ' category-btn--active' : ''}`}
            style={{
              borderColor: color,
              backgroundColor: isActive ? color : undefined,
              color: isActive ? '#fff' : color,
            }}
            onClick={() => onSelect(cat)}
          >
            {t(cat, cat)}
          </button>
        );
      })}
    </div>
  );
}
